// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"34411993","462":"820173fe","498":"ccee8bcf","728":"14c8e373","729":"fb8376b0","978":"f84e56c5"}[chunkId] + ".chunk.css";
};